export default "__VITE_ASSET__Cl80nBUF__"